module.exports = __webpack_public_path__ + "img/dashboard-icon.1b087c34.svg";